// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__uZTve","user-image":"style_user-image__a2ypL"};